import { postRequest } from '@/core';
import { orderTemplates } from '@/requests';

export default async function calculateNextOrderRequest(template) {
	let url = orderTemplates.getNextOrderPath();
	let nextOrder = await postRequest(url, {}, { template });
	return nextOrder;
}